import 'reflect-metadata'
import {injectable} from 'inversify'
import {action, makeAutoObservable, observable} from 'mobx'
import { error } from 'dna-common'
import {storage} from '@/services/storage'
import {ROUTES} from '@/router/routes'
import {getRouterStore} from '@/router/utils'
import {openErrorNotification} from '@/utils'
import {SIGNUP_STORAGE_KEYS} from '../constants'
import {validateEmail} from '../api'
import {IValidateEmailStore} from '~/code/pages/signUp'

@injectable()
export class ValidateEmailStore implements IValidateEmailStore {
    isLoading: boolean = false
    validEmail: string

    constructor() {
        makeAutoObservable(this, {
            isLoading: observable,
            validEmail: observable,

            validateEmail: action.bound
        })
    }

    validateEmail = async (email: string) => {
        try {
            this.isLoading = true

            const {result, error} = await validateEmail(email)

            if (error) {
                openErrorNotification(error?.message)
                return
            }

            if (result) {
                getRouterStore().push(ROUTES.signUpValidateOtpCode)

                storage.set(SIGNUP_STORAGE_KEYS.EMAIL, email)

                this.validEmail = email
            }
        } catch (err) {
            error(err?.message || err)
        } finally {
            this.isLoading = false
        }
    }
}
